import { getScript } from 'js/utils/scripts.util';
import { useCallback } from 'react';

export const useDownloadClientSDK = ({ clientURL }) => {
    return useCallback(async () => {
        if (!window.GeoComply?.Client) {
            await getScript(clientURL, { type: 'module' });
        }

        return window.GeoComply?.Client;
    }, [clientURL]);
};
